import axios from 'axios';

const publicApi = axios.create({
  baseURL: `${process.env.REACT_APP_PUBLIC_API_URL}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// No auth interceptors needed for public APIs
export const getBlogs = async (page = 1, limit = 9) => {
    try {
        const response = await publicApi.get(`/blogs?page=${page}&limit=${limit}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getBlogBySlug = async (slug) => {
    try {
        const response = await publicApi.get(`/blogs/${slug}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};